import React from 'react';
import { Landing } from './pages/Landing';
type AppProps = {
  showPurchaseToast?: boolean;
};
export function App({
  showPurchaseToast = true
}: AppProps) {
  return <Landing showPurchaseToast={showPurchaseToast} data-id="element-0" data-mp="35eoc8jjujrgm" />;
}